import React from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import { useModuleAccess } from '../hooks/useModuleAccess';

type ModuleLinkProps = LinkProps & {
  /** Klassen für den Text, wenn das Ziel nicht erreichbar ist (Standard: className). */
  fallbackClassName?: string;
};

/**
 * Link in ein anderes Modul (Projekt → Kontakt, Rechnung → Projekt …). Ist das Zielmodul für
 * die Instanz abgewählt oder fehlt das Recht, steht derselbe Inhalt als Text da, damit
 * niemand per Klick auf einer gesperrten Seite landet.
 */
export function ModuleLink({ to, children, className, fallbackClassName, style, ...rest }: ModuleLinkProps) {
  const { canOpen } = useModuleAccess();
  const target = typeof to === 'string' ? to : (to.pathname ?? '');
  if (!canOpen(target)) {
    return (
      <span className={fallbackClassName ?? className} style={style} title="Nicht freigeschaltet" aria-disabled="true">
        {children}
      </span>
    );
  }
  return (
    <Link to={to} className={className} style={style} {...rest}>
      {children}
    </Link>
  );
}
